const Home = () => {
    return (
        <div className="flex flex-col items-center justify-center h-full">
            <h1 className="text-3xl font-bold mb-4">Settings Home</h1>
        </div>
    );
}
 
export default Home;